// export const GET_WORKORDER = 'GET_WORKORDER';
// export const GET_WORKORDER_SUCCESS= 'DELETE_GET_SUCCESS';
// export const GET_WORKORDER_ERROR ='DELETE_GET_ERROR';

// export const DELETE_WORKORDER = 'DELETE_WORKORDER';
// export const DELETE_WORKORDER_SUCCESS= 'DELETE_WORKORDER_SUCCESS';
// export const DELETE_WORKORDER_ERROR ='DELETE_WORKORDER_ERROR';

export const    WORKORDER = 'WORKORDER';
export const    WORKORDER_SUCCESS = 'WORKORDER_SUCCESS';
export const    WORKORDER_ERROR = 'WORKORDER_ERROR';

export const    ADD_WORKORDER = 'ADD_WORKORDER';
export const    ADD_WORKORDER_SUCCESS = 'ADD_WORKORDER_SUCCESS';
export const    ADD_WORKORDER_ERROR = 'ADD_WORKORDER_ERROR';

export const    UPDATE_WORKORDER = 'UPDATE_WORKORDER';
export const    UPDATE_WORKORDER_SUCCESS = 'UPDATE_WORKORDER_SUCCESS';
export const    UPDATE_WORKORDER_ERROR = 'UPDATE_WORKORDER_ERROR';

export const DELETE_WORKORDER = 'DELETE_WORKORDER';
export const DELETE_WORKORDER_SUCCESS= 'DELETE_WORKORDER_SUCCESS';
export const DELETE_WORKORDER_ERROR ='DELETE_WORKORDER_ERROR';

export const CLOSE_WORKORDER = 'CLOSE_WORKORDER';
export const CLOSE_WORKORDER_SUCCESS= 'CLOSE_WORKORDER_SUCCESS';
export const CLOSE_WORKORDER_ERROR ='CLOSE_WORKORDER_ERROR';

export  const SYNC_WORKORDERS_TELS_WORKHUBS = 'SYNC_WORKORDERS_TELS_WORXHUBS';
export  const SYNC_WORKORDERS_TELS_WORKHUBS_SUCCESS = 'SYNC_WORKORDERS_TELS_WORXHUBS_SUCCESS';
export  const SYNC_WORKORDERS_TELS_WORKHUBS_ERROR = 'SYNC_WORKORDERS_TELS_WORXHUBS_ERROR';